export default "__VITE_ASSET__ll_kDM$2__"